import defaultV2Client from '@/plugins/axios/defaultV2Client'

export default {
  postBusinessOcr(file, isTest = false) {
    const formData = new FormData()
    formData.append('file', file)

    return defaultV2Client.post(
      `/ocr/biz-license?${isTest === true ? 'isTest=true' : ''}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  },
}
